import styled from 'styled-components';

import { BUTTON_TYPES } from './button.config';

const FORM_ELEMENT_HEIGHT = 32;

function getValueByKeys(obj: any, keys: string[]): string {
  return keys.reduce((acc, key) => acc && acc[key], obj);
}

interface ButtonComponentProps {
  $isLoading: boolean;
  $isDisabled: boolean;
  $buttonType: string;
}

export const ChildContainer = styled.div``;
export const LoadingContainer = styled.div``;

export const ButtonComponent = styled.button<ButtonComponentProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  height: ${FORM_ELEMENT_HEIGHT}px;
  padding: ${({ theme }) => theme.core.sizing[3]}px ${({ theme }) => theme.core.sizing[2]}px;

  font-size: ${({ theme }) => theme.core.fontSizes.ml}px;
  font-weight: ${({ theme }) => theme.core.fontWeight.medium};

  border: 1px solid ${({ theme }) => theme.core.colors.greyscale.black};
  border-radius: ${({ theme }) => theme.core.border.element.radius}px;

  transition: opacity 100ms ease-in-out;

  outline: none;

  opacity: ${({ $isLoading, $isDisabled }) => ($isLoading || $isDisabled ? 0.6 : 1)};

  ${LoadingContainer} {
    position: absolute;
    opacity: ${({ $isLoading }) => ($isLoading ? 1 : 0)};
  }

  ${ChildContainer} {
    display: flex;
    align-items: center;

    opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  }

  color: ${({ theme, $buttonType }) =>
    getValueByKeys(theme.core.colors, BUTTON_TYPES[$buttonType as keyof typeof BUTTON_TYPES].default.color)};

  background: ${({ theme, $buttonType }) =>
    getValueByKeys(theme.core.colors, BUTTON_TYPES[$buttonType as keyof typeof BUTTON_TYPES].default.background)};

  border: 1px solid
    ${({ theme, $buttonType }) =>
      getValueByKeys(theme.core.colors, BUTTON_TYPES[$buttonType as keyof typeof BUTTON_TYPES].default.borderColor)};

  &:hover {
    background: ${({ theme, $buttonType }) =>
      getValueByKeys(theme.core.colors, BUTTON_TYPES[$buttonType as keyof typeof BUTTON_TYPES].hover.background)};

    border: 1px solid
      ${({ theme, $buttonType }) =>
        getValueByKeys(theme.core.colors, BUTTON_TYPES[$buttonType as keyof typeof BUTTON_TYPES].hover.borderColor)};
  }

  &:focus {
    box-shadow: var(
      --focus-ring,
      0 0 0 2px ${({ theme }) => theme.core.colors.greyscale.white},
      0 0 0 4px ${({ theme }) => theme.core.colors.primary.green.medium}
    );
  }
`;
